import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

import { TranslatableLabelFieldComponent } from './translatable-label-field.component';

export interface TranslateDialogData {
    storeId: string;
    title: string;
    label: string;
    labelTranslations: Record<string, string>;
    supportedLocales: string[];
}

export interface TranslateDialogResult {
    labelTranslations: Record<string, string>;
}

@Component({
    selector: 'admin-translate-dialog',
    templateUrl: './translate-dialog.component.html',
    styleUrls: ['./translate-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatDialogActions, MatButton, MatDialogClose, TranslatableLabelFieldComponent],
})
export class TranslateDialogComponent {
    dialogRef = inject<MatDialogRef<TranslateDialogComponent>>(MatDialogRef);
    data = inject<TranslateDialogData>(MAT_DIALOG_DATA);

    constructor() {
    }

    protected closeAndSetLabels() {
        this.dialogRef.close({
            labelTranslations: this.data.labelTranslations,
        } as TranslateDialogResult);
    }
}
